import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface Vendor {
  id: string;
  name: string;
  email: string;
  storeName: string;
  // Matches the API VendorTier enum (apps/api .../vendor.entity.ts).
  tier: 'basic' | 'silver' | 'gold' | 'platinum';
  kycStatus: 'pending' | 'under_review' | 'approved' | 'rejected' | 'suspended';
  avatar?: string;
}

interface VendorState {
  vendor: Vendor | null;
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
}

interface VendorActions {
  setVendor: (vendor: Vendor) => void;
  setTokens: (accessToken: string, refreshToken: string) => void;
  logout: () => void;
}

export const useVendorStore = create<VendorState & VendorActions>()(
  persist(
    (set) => ({
      vendor: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,

      setVendor: (vendor) => set({ vendor }),

      setTokens: (accessToken, refreshToken) => {
        localStorage.setItem('vendor_token', accessToken);
        localStorage.setItem('vendor_refresh_token', refreshToken);
        set({ accessToken, refreshToken, isAuthenticated: true });
      },

      logout: () => {
        localStorage.removeItem('vendor_token');
        localStorage.removeItem('vendor_refresh_token');
        set({ vendor: null, accessToken: null, refreshToken: null, isAuthenticated: false });
      },
    }),
    {
      name: 'vendor-auth',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
